<template>
<div>
  <b-card-group deck>
    <b-card title="Documento de usuario a buscar" class="text-uppercase text-center" id="qr_validate_papeleria">
      <b-col>
        <qrcode-reader @decode="onDecode"></qrcode-reader>
      </b-col>
    </b-card>
  </b-card-group>
</div>
</template>
<script>
export default {
  name: 'validate',
  components: {
    
  },
  data: function () {
    return {
      modalShow: true,
      selected: null,
      idSearch: '',
      options: [
        {
          value: null,
          text: 'Seleccione validacion de credencial'
        },
        {
          value: 1,
          text: 'Mediante codigo'
        },
        {
          value: 2,
          text: 'Mediante QR'
        }
      ]
    }
  },
  methods: {
    setData: function (select) {
      console.log(select)
    },
    searchId: function () {
      console.log(this.idSearch)
      this.$store.dispatch('validateCredentialPapeleria', this.idSearch).then((response) => {
        console.log('respuesta', response)
      }).catch((err) => {
        console.log('respuesta', err)
      })
    },
    onDecode: function (decode) {
      let resp = this.$store.dispatch('validateCredentialPapeleria', decode)
      console.log('respuesta', resp)
      if (resp.code === 2) {
        this.$router.push({
          path: 'papeleria/requests/list'
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/papeleria/requests/validate.vue